"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".root_43a5bbd6{font-size:14px;font-weight:400;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:none;box-shadow:none;margin:0;padding:0;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";box-sizing:border-box;display:block;padding:5px 0;word-wrap:break-word;overflow-wrap:break-word}.isRequired_43a5bbd6::after{content:' *';color:" }, { "theme": "error", "defaultValue": "#a80000" }, { "rawString": "}.isDisabled_43a5bbd6{color:" }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.isDisabled_43a5bbd6{color:GrayText}}\n" }]);
exports.root = "root_43a5bbd6";
exports.isRequired = "isRequired_43a5bbd6";
exports.isDisabled = "isDisabled_43a5bbd6";
//# sourceMappingURL=Label.scss.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/Label/Label.scss.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/Label/Label.scss.js
// module chunks = 1